namespace $.$$ {

	;$shm_hitalama_lib_tg_toHTML

	export class $shm_hitalama_map_widget_float_posts extends $.$shm_hitalama_map_widget_float_posts {

		posts(): readonly ( any )[] {
			// return this.data().messages.map( (m: any, i: number) => {
			return this.data().map( (m: any, i: number) => {
				return this.Post( i )
			} )
		}

		post_text( i: any ): string {
			return this.data()[ i ]
			// return this.data().messages[ id ].content.text.text
		}

		Post_dom( i: any ) {
			const div = document.createElement("div");
			div.innerHTML = this.post_text( i )
			return div
		}
		
		@ $mol_mem
		font_size( next?: number ) {
			return this.widget().font_size( next )
		}

		@ $mol_mem
		font_size_px() {
			return this.font_size() + 'px'
		}
		
		@ $mol_mem
		code( next?: string ): string {
			return this.widget().text( next ) ?? ''
		}

		@ $mol_mem
		code_result() {
			return this.map().execute( this.code(), { [ '$' + 'page' ]: this.Map_page(), [ '$' + 'this_widget' ]: this.widget(), [ '$' + 'view' ]: this } )
		}

		data() {
			const result = this.code_result()
			// A freshly published preset has no code until its initializer resumes.
			if( result === undefined ) return []
			if( result instanceof Error ) throw result
			if( !Array.isArray(result) ) throw new Error('Лента постов: код должен возвращать массив текстов')
			return result
		}

	}
}
